import { render, staticRenderFns } from "./RegisterPage3.vue?vue&type=template&id=591bc1a6&scoped=true&"
import script from "./RegisterPage3.vue?vue&type=script&lang=js&"
export * from "./RegisterPage3.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPage3.vue?vue&type=style&index=0&id=591bc1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591bc1a6",
  null
  
)

export default component.exports